import { Alert, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
    message: string | null;
}

export default function ErrorMsg({ message }: Props) {
    const { t } = useTranslation();
    return (
        <Row>
            {message && (
                <Col xs={12}>
                    <Alert className="pb-0" variant="danger">
                        <p>{t(message)}</p>
                    </Alert>
                </Col>
            )}
        </Row>
    );
}
